// utils/moveMath.ts
export interface AxisTurn {
    axis: string;        // "U", "R", …
    power: 1 | 2 | 3;    // 90 ° clockwise (1), 180 ° (2), 90 ° counter (3)
  }
  
  /** Parse "U", "U'", "U2", "U2'" into { axis, power } */
  export function parseMove(tok: string): AxisTurn | null {
    if(tok==="") return null;
    const [, axis, half] = tok.match(/^([URFDLB])([2]?)'?$/)!;
    if (half) return { axis, power: 2 };
    return tok.endsWith("'")
      ? { axis, power: 3 }          // 3 × 90 ° = -90 ° mod 4
      : { axis, power: 1 };
  }
  
  /** Combine two moves on the *same* axis (mod 4) */
  export function addPowers(a: AxisTurn, b: AxisTurn): AxisTurn {
    return { axis: a.axis, power: (((a.power + b.power) % 4) || 4) as 1 | 2 | 3 };
  }
  
  // utils/moveMath.ts  (only the new bits)

export function simplify(tokens: AxisTurn[]): AxisTurn[] {
    const out: AxisTurn[] = [];
    for (const t of tokens) {
      if (!out.length || out[out.length - 1].axis !== t.axis) {
        out.push({ ...t });
        continue;
      }
      // same axis → combine powers
      const prev = out[out.length - 1];
      const p = (prev.power + t.power) % 4 as 0 | 1 | 2 | 3;
      if (p === 0) out.pop();              // a full 360° cancels
      else prev.power = p as 1 | 2 | 3;
    }
    return out;
  }
  
  /** Count how many tokens of `need` match the start of `have` */
  export function commonPrefixLen(
    have: readonly AxisTurn[],
    need: readonly AxisTurn[]
  ): number {
    let i = 0;
    while (
      i < have.length &&
      i < need.length &&
      have[i].axis === need[i].axis &&
      have[i].power === need[i].power
    )
      i += 1;
    return i;
  }
  